import React from 'react';
import Icon from 'icon';
import Button from 'button';
import Input from '../../../shared/form-input';
import s from './search-bar.module.scss';

export default function SearchBar({ handleSearch, searchField, ...props }) {
  return (
    <div className={s.root}>
      <div className={s.search}>
        <Icon className={s.icon1} icon="search" />
        <Input inputRef={searchField} placeholder="Search Influencer" />
      </div>
      <div className={s.buttonWrapper}>
        <Button onClick={handleSearch} className={s.button}>
          <Icon className={s.icon2} icon="equalizer" />
        </Button>
      </div>
    </div>
  );
}
